import { CaseStyle, convertObjectKeysCase, humanizeString } from '@chillibean/component-library';

import { getBaseAPIUrl } from '../utils';
import { instance as AxiosInstance } from './config';

export const RequestMethod = {
  DELETE: 'delete',
  GET: 'get',
  POST: 'post',
  PUT: 'put',
};

const DEFAULT_CUSTOM_OPTIONS = {
  fullResponse: false,
};

const createLog = (error) => {
  if (error.response?.config?.authenticityToken) {
    try {
      AxiosClient.post({
        data: {
          authenticityToken: error.response.config.authenticityToken,
          logMessage: error ? error.toString() : 'Unknown error',
          logType: error.response.config.logType,
          requestType: error.response.config.method,
          url: error.response.config.url,
        },
        url: `${getBaseAPIUrl()}/logs`,
      });
    } catch (e) {
      // Do nothing
    }
  }
};

export const getLogOptions = (authenticityToken, methodName) => {
  return {
    authenticityToken: authenticityToken,
    logType: humanizeString(methodName),
  };
};

export default class AxiosClient {
  static get({ customOptions = DEFAULT_CUSTOM_OPTIONS, data, options = {}, params, url }) {
    return this.request({
      customOptions: customOptions,
      data: data,
      method: RequestMethod.GET,
      options: options,
      params: params,
      url: url,
    });
  }

  static post({ customOptions = DEFAULT_CUSTOM_OPTIONS, data, options = {}, params, url }) {
    return this.request({
      customOptions: customOptions,
      data: data,
      method: RequestMethod.POST,
      options: options,
      params: params,
      url: url,
    });
  }

  static put({ customOptions = DEFAULT_CUSTOM_OPTIONS, data, options = {}, params, url }) {
    return this.request({
      customOptions: customOptions,
      data: data,
      method: RequestMethod.PUT,
      options: options,
      params: params,
      url: url,
    });
  }

  static delete({ customOptions = DEFAULT_CUSTOM_OPTIONS, data, options = {}, params, url }) {
    return this.request({
      customOptions: customOptions,
      data: data,
      method: RequestMethod.DELETE,
      options: options,
      params: params,
      url: url,
    });
  }

  static async request({ customOptions, data, method, options, params, url }) {
    AxiosInstance.interceptors.response.use(
      (response) => {
        if (response.data instanceof Blob) return response;

        response.data = convertObjectKeysCase({ caseStyle: CaseStyle.CAMEL_CASE, object: response.data });

        return response;
      },

      (error) => {
        if (error.response?.data) {
          /* eslint-disable-next-line prefer-promise-reject-errors */
          return Promise.reject({
            ...error,
            response: {
              ...error.response,
              data: convertObjectKeysCase({ caseStyle: CaseStyle.CAMEL_CASE, object: error.response.data }),
            },
          });
        }

        return Promise.reject(error);
      },
    );
    AxiosInstance.interceptors.request.use(
      (request) => {
        request.params = request.params && convertObjectKeysCase({ object: request.params });
        request.data = request.data && convertObjectKeysCase({ object: request.data });

        return request;
      },
      (error) => Promise.reject(error),
    );

    try {
      const response = await AxiosInstance({
        data,
        method,
        params,
        url,
        ...options,
      });

      if (customOptions.fullResponse) {
        return response;
      }

      return response.data;
    } catch (error) {
      createLog(error);

      return Promise.reject(error);
    }
  }
}
